import React from 'react';
import { AttentionSeeker } from 'react-awesome-reveal';
import LabelParser from '~/sites/music/utils/LabelParser';
import { useChartEditContext } from './ChartEditContext';
import { FaPlus, FaTrash, FaArrowUp, FaArrowDown } from 'react-icons/fa6';
import { TextField } from '@mui/material';
import { Chart } from '~/shared/types/chart';

const WithConditionalAttention = ({ needs_attention, children }: { needs_attention: boolean, children: React.ReactNode }) => (
  needs_attention ?
    <AttentionSeeker effect="jello" triggerOnce={true}>{children}</AttentionSeeker>
    : <>{children}</>
)

export default function ChartLyricsInput() {
  const {
    chart,
    editedChart,
    btnClass,
    recentLyricsI,
    sectionColorClass,
    splitIntoSections,
    addLyricSectionUnder,
    deleteLyricSectionAt,
    nudgeLyrics,
    setEditedChart,
  } = useChartEditContext();

  return (
    <div>
      {editedChart.lyrics.map(
        (lyric_section, lyric_section_i) => {
          const rows = (lyric_section.text || '').split(/\n/).length
          const parser = new LabelParser(lyric_section.label)
          const chord_section_label = parser.parsed.chord_section_label
          const key = `lyric_section_${lyric_section_i}_length_${chart.lyrics.length}`
          const lyricSectionPath = `lyrics.${lyric_section_i}`
          const section_ui = (
            <div key={key} className="section lyric_section">
              <div className="flex flex-col gap-1">
                <div>
                  <input
                    placeholder='Section Label'
                    name={`lyrics.${lyric_section_i}.label`}
                    type='text'
                    className={`text-sm w-full bg-transparent border border-gray-600 rounded px-1 dark inline section-label ${sectionColorClass(chord_section_label)}`}
                    onChange={(e) => setEditedChart(draft => { draft.lyrics[lyric_section_i].label = e.target.value })}
                    value={lyric_section.label || ''}
                  />
                </div>
                <div>
                  <TextField
                    onPaste={e => splitIntoSections(e, lyricSectionPath)}
                    variant='filled'
                    placeholder='Section Lyrics'
                    size="small"
                    multiline
                    fullWidth
                    minRows={rows}
                    onChange={(e) => setEditedChart(draft => { draft.lyrics[lyric_section_i].text = e.target.value })}
                    value={lyric_section.text || ''}
                  />

                </div>
                <div className="flex gap-1 mt-1">
                  <button onClick={() => addLyricSectionUnder(lyric_section_i)} className={btnClass}>
                    <FaPlus />
                  </button>
                  <button
                    name={`lyrics.${lyric_section_i}`}
                    onClick={() => deleteLyricSectionAt(lyric_section_i)}
                    className={btnClass}>
                    <FaTrash />
                  </button>
                  <button
                    title='move section up'
                    className={btnClass}
                    name={`lyrics.${lyric_section_i}`}
                    onClick={() => nudgeLyrics('up', lyric_section_i)}
                  >
                    <FaArrowUp />
                  </button>
                  <button
                    title='move section down'
                    className={btnClass}
                    name={`lyrics.${lyric_section_i}`}
                    onClick={() => nudgeLyrics('down', lyric_section_i)}
                  >
                    <FaArrowDown />
                  </button>
                </div>
              </div>
            </div>
          )

          return (
            <WithConditionalAttention key={key} needs_attention={lyric_section_i === recentLyricsI}>
              {section_ui}
            </WithConditionalAttention>
          )
        }
      )}
      <div className="section">
        <div className="text-right">
          <button
            onClick={() => addLyricSectionUnder(chart.lyrics.length - 1)}
            className={btnClass}>
            <FaPlus className='inline' /> {' '} Lyric Section
          </button>
        </div>
      </div>
    </div>
  );
}
